import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component( {
	selector: "app-input-field",
	templateUrl: "./input-field.component.html",
	styleUrls: [ "./input-field.component.scss" ]
} )
export class InputFieldComponent {
	@Input() inputType: string = "text";
	@Input() nzSuffix: TemplateRef<any>;
	@Input() nzPrefix: TemplateRef<any>;
	@Input() form: FormGroup;
	@Input() label: string = null;
	@Input() placeholder: string;
	@Input() formName: string;
	@Input() size: string;
	@Input() footNote: string = "";
	@Input() showValidationError: boolean = true;
	@Output() ngModelChange = new EventEmitter<any>();

	constructor() {
	}

	handleOnChange( $event ) {
		// ... all of your logic
		this.ngModelChange.emit( $event ); // this will pass the $event object to the parent component.
	}

}
